import { PractitionersPage } from '@/pages/Practitioners';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

const PractitionerSearchSchema = z.object({
  search: z.string().default(''),
  organizationId: z.string().min(1).optional(),
  pageSize: z.number().int().min(1).max(1000).default(20),
});

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { search, organizationId, pageSize } = Route.useSearch();
  // oxlint-disable-next-line no-use-before-define
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <PractitionersPage
      search={search}
      setSearch={(search) => {
        void navigate({ search: (prev) => ({ ...prev, search }) });
      }}
      organizationId={organizationId}
      setOrganizationId={(organizationId) => {
        void navigate({ search: (prev) => ({ ...prev, organizationId }) });
      }}
      pageSize={pageSize}
      setPageSize={(pageSize) => {
        void navigate({ search: (prev) => ({ ...prev, pageSize }) });
      }}
    />
  );
};

export const Route = createFileRoute('/_auth/practitioners/')({
  component: RouteComponent,
  loader: () => ({ crumb: 'Practitioners' }),
  validateSearch: PractitionerSearchSchema,
});
